import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
export function promisify(name) {
  return function (obj) {
    return new Promise(function (resolve, reject) {
      obj = obj || {};

      obj.success = function () {
        resolve();
      };

      obj.complete = function (err) {// resolve();
      };

      obj.fail = function (err) {
        reject();
      }; // @ts-ignore


      wx[name](obj);
    })["catch"](function (err) {
      return err;
    });
  };
} // api

var apiNames = ['onMenuShareAppMessage', 'onMenuShareTimeline', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'closeWindow', 'hideOptionMenu', 'chooseWXPay', 'getLocation', 'getLocalImgData', 'hideMenuItems', 'showMenuItems', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'];
export var wxApi = {};
apiNames.forEach(function (name) {
  // @ts-ignore
  wxApi[name] = promisify(name);
});